import React, { useState } from "react";
import "../styles/Header.css";
import logo from "../assets/images/LOGO.png";
import { Link } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [digestionDropdownOpen, setDigestionDropdownOpen] = useState(false);
  const [menWellnessDropdownOpen, setMenWellnessDropdownOpen] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState(false);
  const [mobileDigestionDropdown, setMobileDigestionDropdown] = useState(false);
  const [mobileMenWellnessDropdown, setMobileMenWellnessDropdown] = useState(false);

  const diabetesProducts = [
    { name: "Madhumeh", slug: "madhumeh-sugar-powder" },
    { name: "Diacare Powder", slug: "diacare-powder" },
    { name: "Diacorex Tablet", slug: "diacorex-tablet" },
  ];

  const digestionProducts = [
    { name: "Pachan Care Powder", slug: "paachan-care-powder" },
    { name: "Liver Care Tablet", slug: "liver-care-tablet" },
  ];

  const menWellnessProducts = [
    { name: "Shilajit Plus", slug: "shilajit-plus" },
    { name: "Stamina", slug: "stamina" },
  ];

  const closeMobileMenu = () => {
    setOpen(false);
    setMobileDropdown(false);
    setMobileDigestionDropdown(false);
    setMobileMenWellnessDropdown(false);
  };

  return (
    <>
      <header className="sw-header">
        <div className="sw-left">
          <div className="sw-logo">
            <Link to="/">
              <img src={logo} alt="Sankalp Ayurveda" />
            </Link>
          </div>
          <button className="menu-btn" onClick={() => setOpen(true)}>
            ☰
          </button>
        </div>

        <nav className="sw-nav">
          <Link to="/" className="nav-item">
            Home
          </Link>

          <Link to="/About" className="nav-item">
            About Us
          </Link>
          <div
            className="nav-item dropdown"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <span className="dropdown-trigger">Diabetes Support </span>
            <div className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
              {diabetesProducts.map((product) => (
                <Link
                  key={product.slug}
                  to={`/products/${product.slug}`}
                  className="dropdown-link"
                >
                  {product.name}
                </Link>
              ))}
            </div>
          </div>

          <div
            className="nav-item dropdown"
            onMouseEnter={() => setDigestionDropdownOpen(true)}
            onMouseLeave={() => setDigestionDropdownOpen(false)}
          >
            <span className="dropdown-trigger">Digestion Products </span>
            <div
              className={`dropdown-menu ${digestionDropdownOpen ? "show" : ""}`}
            >
              {digestionProducts.map((product) => (
                <Link
                  key={product.slug}
                  to={`/products/${product.slug}`}
                  className="dropdown-link"
                >
                  {product.name}
                </Link>
              ))}
            </div>
          </div>

          <div
            className="nav-item dropdown"
            onMouseEnter={() => setMenWellnessDropdownOpen(true)}
            onMouseLeave={() => setMenWellnessDropdownOpen(false)}
          >
            <span className="dropdown-trigger">Men Wellness </span>
            <div
              className={`dropdown-menu ${menWellnessDropdownOpen ? "show" : ""}`}
            >
              {menWellnessProducts.map((product) => (
                <Link
                  key={product.slug}
                  to={`/products/${product.slug}`}
                  className="dropdown-link"
                >
                  {product.name}
                </Link>
              ))}
            </div>
          </div>

          <Link to="/Contact" className="nav-item">
            Contact Us
          </Link>
        </nav>

        <div className="sw-social">
          <a
            href="https://wa.me"
            target="_blank"
            rel="noopener noreferrer"
            title="WhatsApp"
          >
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>
      </header>

      {/* Mobile Side Menu */}
      <aside className={`side-menu ${open ? "show" : ""}`}>
        <div className="side-header">
          <span>Sankalp Ayurveda</span>
          <button onClick={() => setOpen(false)}>✕</button>
        </div>

        <Link to="/" className="side-menu-link" onClick={closeMobileMenu}>
          Home
        </Link>
 <Link to="/About" className="side-menu-link">
            About Us
          </Link>
        <div
          className="mobile-dropdown"
          onClick={() => setMobileDropdown(!mobileDropdown)}
        >
          Diabetes Support
        </div>
        {mobileDropdown && (
          <div className="mobile-dropdown-menu">
            {diabetesProducts.map((product) => (
              <Link
                key={product.slug}
                to={`/products/${product.slug}`}
                className="mobile-dropdown-item"
                onClick={closeMobileMenu}
              >
                {product.name}
              </Link>
            ))}
          </div>
        )}

        <div
          className="mobile-dropdown"
          onClick={() => setMobileDigestionDropdown(!mobileDigestionDropdown)}
        >
          Digestion Products
        </div>
        {mobileDigestionDropdown && (
          <div className="mobile-dropdown-menu">
            {digestionProducts.map((product) => (
              <Link
                key={product.slug}
                to={`/products/${product.slug}`}
                className="mobile-dropdown-item"
                onClick={closeMobileMenu}
              >
                {product.name}
              </Link>
            ))}
          </div>
        )}

        <div
          className="mobile-dropdown"
          onClick={() => setMobileMenWellnessDropdown(!mobileMenWellnessDropdown)}
        >
          Men Wellness
        </div>
        {mobileMenWellnessDropdown && (
          <div className="mobile-dropdown-menu">
            {menWellnessProducts.map((product) => (
              <Link
                key={product.slug}
                to={`/products/${product.slug}`}
                className="mobile-dropdown-item"
                onClick={closeMobileMenu}
              >
                {product.name}
              </Link>
            ))}
          </div>
        )}

        <Link
          to="/Contact"
          className="side-menu-link"
          onClick={closeMobileMenu}
        >
          Contact Us
        </Link>
      </aside>
      {open && <div className="backdrop" onClick={() => setOpen(false)} />}
    </>
  );
};

export default Header;
